import classNames from 'classnames';
import React, { ReactNode } from 'react';
import styles from './TwoPanelLayout.module.scss';

export const TwoPanelLayout: React.FC<{
    leftPanelOpen?: boolean;
    rightPanelOpen?: boolean;
    noPadding?: boolean;
    mask?: boolean;
    maskContents?: boolean;
    contentsLeft?: boolean;
    leftPanel?: ReactNode;
    rightPanel?: ReactNode;
    contents: ReactNode;
    toolbar?: ReactNode;
    secondaryToolbar?: ReactNode;
    header?: ReactNode;
}> = props => {
    const twoPanelClass = classNames(styles.twoPanelLayout);

    const rightPanelClass = classNames(styles.rightPanel, {
        [styles.rightPanelOpen]: props.rightPanelOpen
    });

    const leftPanelClass = classNames(styles.leftPanel, {
        [styles.leftPanelOpen]: props.leftPanelOpen,
        [styles.noPadding]: props.noPadding
    });

    const contentsPanelClass = classNames(styles.contentsPanel, {
        [styles.contentsPanelLeftOpen]: props.leftPanelOpen,
        [styles.contentsPanelRightOpen]: props.rightPanelOpen,
        [styles.contentsLeft]: props.contentsLeft
    });

    const contentMaskClass = classNames(styles.contentsMask);

    return (
        <>
            {props.header}

            <main className={twoPanelClass}>
                {!!props.toolbar && <div className={styles.toolbar}>{props.toolbar}</div>}
                {!!props.secondaryToolbar && <div className={styles.secondaryToolbar}>{props.secondaryToolbar}</div>}

                <section className={styles.contentArea}>
                    <aside className={leftPanelClass}>{props.leftPanel}</aside>
                    <article className={contentsPanelClass}>
                        {props.contents}
                        {props.children}
                        {props.mask && <div className={contentMaskClass} />}
                    </article>
                    {props.rightPanel && <aside className={rightPanelClass}>{props.rightPanel}</aside>}
                </section>
            </main>
        </>
    );
};
